import React from "react";
import "../styles/Sidebar.css";
import { useParams } from "react-router-dom";

const Sidebar = () => {
  const { id, urlTitle } = useParams();
  let homeLink = "";
  let linksData = JSON.parse(sessionStorage.getItem("courseInternalLinks"));
  if (linksData !== undefined && linksData !== null) {
    homeLink = linksData.filter((item) => item.name == "Home");
  } else {
    if (
      id !== null &&
      id !== undefined &&
      id !== "" &&
      urlTitle !== null &&
      urlTitle !== undefined &&
      urlTitle !== ""
    ) {
      let linksData = [
        { name: "Home", uri: `/program-internal/${id}/${urlTitle}` },
        { name: "My Journal", uri: `/program-internal/module/my-journal/:id` },
      ];
      sessionStorage.setItem("courseInternalLinks", JSON.stringify(linksData));
      homeLink = [{ name: "Home", uri: `/program-internal/${id}/${urlTitle}` }]
    }
  }

  const sidebar_data = [
    {
      img: "/assets/img/course_internal_journey/sidebar/sidebar-home.png",
      text: "Home",
      link: homeLink[0].uri,
    },
    {
      img: "/assets/img/course_internal_journey/sidebar/sidebar-mood-monitor.png",
      text: "Mood Monitor",
      link: "/program-internal/module/mood-monitor",
    },
    {
      img: "/assets/img/course_internal_journey/sidebar/my-library.png",
      text: "My Library",
      link: "/program-internal/library",
    },
  ];
  return (
    <>
      <section className="sidebar-section">
        <div className="sidebar-list">
          {sidebar_data.map((item, i) => (
            <div
              className="sidebar-li"
              onClick={() => {
                window.location.pathname = item.link;
              }}
            >
              <img
                src={item.img}
                className="sidebar-img"
                alt=""
                loading="lazy"
              />
              <p>{item.text}</p>
            </div>
          ))}
        </div>

        <div className="sidebar-app d-none">
          <div className="sidebar-app-heading">
            <img src="/assets/img/course_internal_journey/kareifySmall" width={25} height={25} />
            <p>Use App</p>
          </div>
          <div className="sidebar-app-qr">
            <img src="/assets/img/course_internal_journey/UWC_QR" />
            <p className="sidebar-qr-text">
              Scan this QR code to use our mobile app
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Sidebar;
